<script lang="ts">
  /**
   * StarField - Animated background with twinkling stars
   * Creates an immersive space theme atmosphere
   */

  // Generate random stars for the background
  const starCount = 100;
  const stars = Array.from({ length: starCount }, (_, i) => ({
    id: i,
    x: Math.random() * 100, // Position as percentage
    y: Math.random() * 100,
    size: Math.random() * 2 + 1, // Size between 1-3px
    duration: Math.random() * 3 + 2, // Animation duration 2-5s
    delay: Math.random() * 5 // Stagger animation start
  }));
</script>

<div class="starfield">
  {#each stars as star (star.id)}
    <div
      class="star"
      style="
        left: {star.x}%;
        top: {star.y}%;
        width: {star.size}px;
        height: {star.size}px;
        animation-duration: {star.duration}s;
        animation-delay: {star.delay}s;
      "
    />
  {/each}
</div>

<style>
  .starfield {
    position: absolute;
    inset: 0;
    overflow: hidden;
    background: linear-gradient(180deg, var(--color-space-deep) 0%, var(--color-space-blue) 100%);
    z-index: 0;
  }

  .star {
    position: absolute;
    background: white;
    border-radius: 50%;
    animation: twinkle infinite ease-in-out;
    box-shadow: 0 0 2px rgba(255, 255, 255, 0.8);
  }

  @keyframes twinkle {
    0%, 100% {
      opacity: 0.3;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
</style>
